// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tovSH","newExpiryDate":"styles_newExpiryDate__3VR6v","footer":"styles_footer__2xhaq"};